import { IRectangleCoordinatable, ISize } from "../../../../../../../base/domain/drawing";
import { IRectangleCoordinatableObjectBean } from "../../../beans/objects";
import { IntegerTranslator } from "../../values";

export class SizeTranslator {
  from(bean: IRectangleCoordinatableObjectBean): ISize {
    return {
      width: this.integer.from(bean["@width"]),
      height: this.integer.from(bean["@height"]),
    };
  }

  to(object: IRectangleCoordinatable): ISize<string> {
    return {
      width: this.integer.to(object.size.width),
      height: this.integer.to(object.size.height),
    };
  }

  private readonly integer = new IntegerTranslator();
}
